import axios from 'axios';
import path from '../../path';

// Helper function to get token
const getToken = () => {
    const token = sessionStorage.getItem("token");
    if (!token) {
        throw new Error("No token found in session storage.");
    }
    return token;
};

// Helper function to build query parameters
const buildParams = (bvdqScore, country, birthday, search, providerId) => {
    const params = {};
    if (bvdqScore) params.bvdqScore = bvdqScore;
    if (country) params.country = country;
    if (birthday) params.birthday = birthday;
    if (search) params.search = search;
    if (providerId) params.providerId = providerId;
    return params;
};

// Generic API call handler
const fetchLeads = (endpoint, id = null, bvdqScore = null, country = null, birthday = null, search = null, providerId = null) => {
    const token = getToken();
    const params = buildParams(bvdqScore, country, birthday, search, providerId);

    return axios.get(`${path}${endpoint}${id ? `/${id}` : ''}`, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
        params,
    });
};

// Specific API functions
export const getPipeLineLeadsApi = (id, bvdqScore = null, country = null, birthday = null, search = null) => {
    return fetchLeads('/v1/user/pipeline-get-leads', id, bvdqScore, country, birthday, search);
};

export const getAllPipeLineLeadsApi = (bvdqScore = null, providerId = null, birthday = null, search = null) => {
    return fetchLeads('/v1/user/pipeline-get-all-leads', null, bvdqScore, null, birthday, search, providerId);
};
